import { ISalesAccount } from "models/salesAccount/salesAccount.model";

export const getSalesAccountChannel = (
  salesAccountUUID: ISalesAccount["uuid"]
) => {
  return `private-sales-account-${salesAccountUUID}`;
};
